import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { enqueueSnackbar } from "notistack";
import { getErrorMessage } from "./errorMessages";
//function to handle errors and display them to the user
const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};

// utilities for get users that arent assigned to a specific report
export const assignUserToReport = async (user_id, report_id, rolesInvestigation, rolesResolution, details, externalUserName = null) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/assignment/manual/`,
      { user_id, report_id, rolesInvestigation, rolesResolution, details, externalUserName },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "assignments"));
    console.error(error);
  }
};

// utilities for get users that arent assigned to a specific report
export const deleteUserFromReport = async (user_id, report_id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.delete(`${tenant}/api/assignment/manual/`, {
      data: { user_id, report_id },
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "assignments"));
    console.error(error);
  }
};

// utilities for get users that arent assigned to a specific report
export const updateUserFromReport = async (id, assign_details, report_id) => {
  console.log({ id, assign_details, report_id });
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.put(`${tenant}/api/report/update-users-from-report/?report_id=${report_id}`, 
      { id, assign_details },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
    });
    return resp.data;
  } catch (error) {
    const errorMessage = getErrorMessage(error, "assignments");
    showErrorMessage(errorMessage);
    throw new Error(errorMessage, { cause: error });
  }
};

